import { PortableText } from "next-sanity";
import { richTextComponent } from "@/sanity/sanityPortableText";
import {
  PagePricingSchema,
  PricingForWhoCard,
} from "@/sanity/pages/PagePricingTemplate";
import dotsGradientBg from "@/public/global/dots-gradient-bg.png";
import Image from "next/image";
import { CTAButton } from "@/shadcn/ui/button";

function DollarIcon() {
  return (
    <svg
      className="w-[4.625rem] h-[4.625rem] shrink-0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 37 37"
      fill="none"
    >
      <path
        d="M26.5938 23.7206C26.5938 18.3843 22.2231 17.7762 18.7115 17.2884C14.8843 16.7554 12.7188 16.294 12.7188 12.9987C12.7188 10.2318 15.6176 9.25 18.0997 9.25C19.3369 9.20998 20.5658 9.46462 21.6852 9.99292C22.8045 10.5212 23.7823 11.308 24.5378 12.2885L26.3372 10.8365C25.528 9.79611 24.5213 8.92589 23.3747 8.27586C22.2282 7.62583 20.9645 7.20879 19.6563 7.04873V3.46875H17.3438V6.96294C13.1637 7.21639 10.4063 9.57606 10.4063 12.9986C10.4063 18.4676 14.8347 19.0836 18.3931 19.5776C22.1538 20.1012 24.2813 20.5517 24.2813 23.7206C24.2813 27.2267 20.6592 27.75 18.5 27.75C14.5348 27.75 12.8596 26.6355 11.3059 24.7115L9.50658 26.1635C10.4232 27.3714 11.6088 28.349 12.9692 29.0188C14.3297 29.6885 15.8275 30.0319 17.3438 30.0218V33.5312H19.6563V30.0106C23.964 29.6589 26.5938 27.3198 26.5938 23.7206Z"
        fill="#206B57"
      />
    </svg>
  );
}

function ClipboardIcon() {
  return (
    <svg
      className="w-[4.625rem] h-[4.625rem] shrink-0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 37 37"
      fill="none"
    >
      <path d="M13.875 18.5H6.9375V20.8125H13.875V18.5Z" fill="#206B57" />
      <path d="M18.5 13.875H6.9375V16.1875H18.5V13.875Z" fill="#206B57" />
      <path d="M18.5 9.25H6.9375V11.5625H18.5V9.25Z" fill="#206B57" />
      <path
        d="M16.1875 30.0625H4.625V6.9375H32.375V18.5H34.6875V6.9375C34.6875 6.32419 34.4439 5.73599 34.0102 5.30232C33.5765 4.86864 32.9883 4.625 32.375 4.625H4.625C4.01169 4.625 3.42349 4.86864 2.98982 5.30232C2.55614 5.73599 2.3125 6.32419 2.3125 6.9375V30.0625C2.3125 30.6758 2.55614 31.264 2.98982 31.6977C3.42349 32.1314 4.01169 32.375 4.625 32.375H16.1875V30.0625Z"
        fill="#206B57"
      />
      <path
        d="M25.4375 29.5884L22.4428 26.5938L20.8125 28.2241L25.4375 32.8491L34.6875 23.5991L33.0572 21.9688L25.4375 29.5884Z"
        fill="#206B57"
      />
    </svg>
  );
}

function BoltIcon() {
  return (
    <svg
      className="w-[4.625rem] h-[4.625rem] shrink-0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 37 37"
      fill="none"
    >
      <path
        d="M13.4241 34.595C13.1875 34.4951 12.9908 34.3193 12.8652 34.0953C12.7396 33.8713 12.6921 33.6118 12.7303 33.3578L14.8347 19.6563H9.25002C9.07297 19.661 8.89719 19.6251 8.73625 19.5511C8.57531 19.4772 8.4335 19.3673 8.32177 19.2298C8.21004 19.0924 8.13137 18.9311 8.09184 18.7585C8.05231 18.5858 8.05297 18.4064 8.09377 18.2341L11.5625 3.20282C11.6236 2.94413 11.7719 2.71437 11.9825 2.55222C12.193 2.39006 12.4531 2.30541 12.7188 2.31251H24.2813C24.454 2.31192 24.6247 2.35005 24.7808 2.42408C24.9368 2.49811 25.0743 2.60617 25.1832 2.74032C25.2935 2.87599 25.3717 3.03492 25.4117 3.20515C25.4518 3.37539 25.4527 3.55249 25.4144 3.72314L23.4141 12.7188H28.9063C29.123 12.7183 29.3354 12.7788 29.5194 12.8933C29.7034 13.0078 29.8516 13.1717 29.9469 13.3663C30.0298 13.553 30.0616 13.7584 30.0393 13.9615C30.017 14.1646 29.9412 14.3582 29.8197 14.5225L14.7885 34.1788C14.6869 34.3294 14.5512 34.4539 14.3925 34.5423C14.2338 34.6307 14.0565 34.6804 13.875 34.6875C13.7203 34.6846 13.5674 34.6533 13.4241 34.595ZM20.5235 15.0313L22.836 4.62501H13.6438L10.7069 17.3438H17.5403L15.7019 29.23L26.5938 15.0313H20.5235Z"
        fill="#206B57"
      />
    </svg>
  );
}

const CARD_ICONS = {
  dollar: DollarIcon,
  clipboard: ClipboardIcon,
  bolt: BoltIcon,
} as const;

function ForWhoCard({ card }: { card: PricingForWhoCard }) {
  const Icon = card.icon ? CARD_ICONS[card.icon] : null;

  return (
    <div
      className="relative overflow-hidden flex flex-col items-center gap-[2.75rem] pt-[1.25rem] px-[1.25rem] pb-[5rem]
                    bg-[#04271D] border border-black/10 rounded-[0.25rem]"
    >
      <Image
        src={dotsGradientBg}
        alt=""
        fill
        className="absolute inset-0 object-cover object-top pointer-events-none select-none mix-blend-exclusion"
      />

      {/* Title + description – lighter panel */}
      <div
        className="relative w-full min-h-[30.125rem] bg-white/10 rounded-[0.25rem]
                      flex flex-col items-center justify-center gap-[2.5rem]
                      py-[3.75rem] px-[2.375rem] text-center"
      >
        {/* Icon badge – fully inside the card, no overflow */}
        <div
          className="flex items-center justify-center
                        bg-white border-b-[3px] border-[#85DDC5] rounded-[0.25rem]
                        w-[7.375rem] h-[7.375rem] p-[1.08rem]"
        >
          {Icon && <Icon />}
        </div>

        {card.title && (
          <p className="font-semibold text-[3.5rem] leading-[1.06] text-white tracking-[-0.175rem] lg:whitespace-nowrap">
            {card.title}
          </p>
        )}
        {card.description && (
          <div className="w-fit max-w-[37.875rem] mx-auto text-[2rem] leading-[1.35] text-white/60 [text-wrap-style:pretty] [&_.p-normal]:!text-white/60">
            <PortableText
              value={card.description}
              components={richTextComponent}
            />
          </div>
        )}
      </div>

      {/* Bottom text – width hugs its own content per card, balanced like Figma's auto-layout */}
      {card.bottomText && (
        <div className="w-fit max-w-[41.5rem] mx-auto text-[2rem] leading-[1.35] text-white text-center [text-wrap-style:pretty] [&_.p-normal]:!text-white">
          <PortableText
            value={card.bottomText}
            components={richTextComponent}
          />
        </div>
      )}
    </div>
  );
}

export default function ForWhoSection({ data }: { data: PagePricingSchema }) {
  const cards = data?.forWhoCards ?? [];

  return (
    <section className="w-full bg-white py-[8rem] lg:py-[16rem] relative">
      <div className="absolute w-[calc(100%+50rem)] lg:w-full h-[48rem] top-0 left-1/2 -translate-x-1/2 mix-blend-exclusion pointer-events-none select-none">
        <Image fill alt="Background pattern" src={dotsGradientBg} />
      </div>
      <div className="mx-auto w-[min(170.5rem,calc(100%-4rem))] lg:w-[min(170.5rem,calc(100%-8rem))] flex flex-col items-center gap-[6rem]">
        {/* Header */}
        <div className="flex flex-col items-center gap-[1.5rem] text-center">
          {data?.forWhoChip && (
            <p className="mb-0 font-blacker italic text-[2rem] leading-[1.5] text-black">
              {data.forWhoChip}
            </p>
          )}
          {data?.forWhoTitle && (
            <div
              className="richtext max-w-[80rem]
                            prose-headings:text-[4.5rem] lg:prose-headings:text-[6rem] prose-headings:leading-[1.12]
                            prose-headings:tracking-[-0.3rem] prose-headings:font-medium
                            prose-headings:text-black
                            prose-em:font-blacker prose-em:italic prose-em:text-[#003828]"
            >
              <PortableText
                value={data.forWhoTitle}
                components={richTextComponent}
              />
            </div>
          )}
        </div>

        {/* Cards */}
        {cards.length > 0 && (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-[4.5rem] w-full">
            {cards.map((card, i) => (
              <ForWhoCard key={card._key ?? i} card={card} />
            ))}
          </div>
        )}

        {data?.forWhoButton && (
          <div className="w-full lg:w-fit">
            <CTAButton data={data.forWhoButton} />
          </div>
        )}
      </div>
    </section>
  );
}
